import { render } from "./ContextMenuForm.vue?vue&type=template&id=673577aa"
import script from "./ContextMenuForm.vue?vue&type=script&lang=js"
export * from "./ContextMenuForm.vue?vue&type=script&lang=js"

import "./ContextMenuForm.vue?vue&type=style&index=0&id=673577aa&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__